module.exports = __webpack_public_path__ + "img/acacia_mweya1.7fe9e5dd.jpg";